import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useTranslations } from '../../locales/useTranslations';
import { BiLogoLinkedin, BiSolidEnvelope, BiMobile, BiLogoInstagram } from "react-icons/bi";

const Footer = () => {
    let currentYear = new Date().getFullYear();
    const { t } = useTranslations();
    return (

        <footer className="footer-area-new">
            <div className="container">
                <div className="row">
                    <div className="col-lg-2 col-md-6 col-sm-6">

                        <div className="single-footer-widget">
                            <div className="logo">
                                <a href="/">
                                    <Image src="/images/white-logo.png" alt="simplify data - Logo"
                                        width={40}
                                        height={40} />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6 col-sm-6">
                        <div className="single-footer-widget">
                            <div className="footer-header">{t('ourServices')}</div>

                            <ul className="support-lists">
                                <li>
                                    <Link href="/app-development/">
                                        {t('navAppDevelopment')}
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/web-development/">
                                        {t('navWebDevelopment')}
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/software-development/">
                                        {t('navSoftwareDevelopment')}
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/it-consulting/">
                                        {t('navItConsulting')}
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/business-analytics/">
                                        {t('navBusinessAnalytics')}
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/kuenstliche-intelligenz/">
                                        {t('navArtificialIntelligence')}
                                    </Link>
                                </li>
                            </ul>

                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6 col-sm-6">
                        <div className="single-footer-widget">
                            <div className="footer-header">{t('serviceAndLegal')}</div>

                            <ul className="support-lists">
                                <li>
                                    <Link href="https://ticket.simplify-data.de" target="_blank">
                                        {t('ticketSystem')}
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/impressum">
                                        {t('imprint')}
                                    </Link>
                                </li>

                                <li>
                                    <Link href="/datenschutz">
                                        {t('privacyPolicy')}
                                    </Link>
                                </li>
                                {/** #temp
                            <li>
                                <Link href="/jobs">
                                    <a>Stellenangebote</a>
                                </Link>
                            </li>
                            **/}

                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-footer-widget">
                            <div className="footer-header">{t('navContact')}</div>

                            <ul className="support-lists">
                                <li>Simplify Data GmbH</li>
                                <li>Königsweg 48, 24114 Kiel</li>
                                <li>{t('phone')}: <span><Link href="tel://+4943170577024">0431 705 770 24</Link></span></li>
                                <li>{t('email')}: <span><Link href="mailto:info@simplify-data.de">info@simplify-data.de</Link></span></li>
                            </ul>
                            <ul className="social">
                                <li>
                                    <Link href="tel://+4943170577024" target="_blank" title={t('phone')}>
                                        <BiMobile style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
                                    </Link>
                                </li>

                                <li>
                                    <Link href="mailto:info@simplify-data.de" target="_blank" title={t('email')}>
                                        <BiSolidEnvelope style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        href="https://www.linkedin.com/company/simplify-data-gmbh" title='LinkedIn'
                                        target="_blank">
                                        <BiLogoLinkedin style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
                                    </Link>
                                </li>

                                <li>
                                    <Link href="https://www.instagram.com/simplify.data/" target="_blank" title='Instagram'>
                                        <BiLogoInstagram style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
                                    </Link>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright-areas">
                <p>{t('copyright')} &copy; {currentYear} Simplify Data GmbH</p>
            </div>
        </footer >
    );

}
export default Footer;